import { types } from "../constants/types";
// reducers/postReducer.js
const initialState = {
  dashData: {},
  purchaseSummaryData: [],
  serviceTypeData: {},
  allPlans: {},
  countries:[],
  superAdminList:{},
  profileData: {},
  loading: false,
  error: null,
};

const otherReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SERVICETYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_SERVICETYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceTypeData: action.payload,
      };
    case types.GET_SERVICETYPE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case types.GET_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.payload,
      };
    case types.GET_COUNTRY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_SUPERADMIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_SUPERADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        superAdminList: action.payload,
      };
    case types.GET_SUPERADMIN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

   


    default:
      return state;
  }
};

export default otherReducer;
